import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default {
  state: {
    fetchDataCount: 0, // 请求异常次数
    guideWords: ['诗歌', '季节'],
    guideOptions: ['情感共鸣', '短'],
    isGuide: false, // 是否是新手引导
    originTemplateData: [], // 原始模板数据
    currentWriteFrom: 1, // 1.当前写作，2.历史写作
    ability: [], // 调整选项
    currentTemplate: -1, // 当前选中的模板索引
    currentTemplateCate: 0, // 当前选中的模板分类索引
    templateCate: [], // 模板分类
    editingInstruct:'',
    promptData: {},
    defaultPromptData:{},
    writeDbinstance: {}, //写作数据库实例
    currentConversationId: '', // 当前的ConversationId
    toBeShowConversationId: '', //需要展示的 会话ID
  },
  mutations: {
    fetchDataCount(state, payload) {
        state.fetchDataCount = payload
    },
    updateIsGuide(state, payload) {
        state.isGuide = payload
    },
    updateOriginTemplateData(state, payload) {
        state.originTemplateData = payload
    },
    updateCurrentWriteFrom(state, payload) {
        state.currentWriteFrom = payload
    },
    updateAbility(state, payload) {
        state.ability = payload
    },
    updateCurrentTemplateCate(state, payload) {
        state.currentTemplateCate = payload
    },
    updateCurrentTemplate(state, payload) {
        state.currentTemplate = payload
    },
    updateTemplateCate(state, payload) {
        state.templateCate = payload
    },
    updataWriteConversations(state, payload) {
        state.conversations = payload
    },
    updatePromptData(state, payload) {
        // console.error('updatePromptData', payload);
        state.promptData = payload;
    },
   
    assignWriteDbinstance(state, payload) {
      state.writeDbinstance = payload;
    },
    setCurrentConversationId(state, currentConversationId) {
      state.currentConversationId = currentConversationId
    },
    // assignToBeShowConversationId(state, payload){
    //   state.toBeShowConversationId = payload;
    // },
  },
  actions: {
    
  },
  getters: {
    writePrompt: (state) => {
      const {
        prompt,
        inputTextareaContent,
        currentTemplateData,
      } = state.promptData
      if (!currentTemplateData) return ''
      const others = []
      for (let index = 0; index < currentTemplateData.select.length; index++) {
        const item = currentTemplateData.select[index]
        others.push(`【${item.name}】: ${item.options[item.currentIndex]}`)
      }
      const othersString = others.join('。')
      const result = prompt
        .replace('具体文章类型', currentTemplateData.name)
        .replace('输入框内容', inputTextareaContent)
        .replace('其他特定要求', othersString)
      return result

      /*
      return prompt
        .replace('[类型]', writingType[writingTypeIndex]?.title)
        .replace('[输入框内容]', inputTextareaContent)
        .replace('[语气]', tone[toneIndex])
        .replace('[长度]', length[lengthIndex]);
        */
    },
    currentConversationMsg: state => {
      return state.conversations[state.conversations.length - 1];
    }
  },
  namespaced: true
}